import { Modal } from '@carbon/react';
import { defineMessages, useIntl } from 'react-intl';

import sharedMessages from 'Components/utils/sharedMessages';
import { InputElement } from 'Components/Common/TagsInput/types';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (tag: InputElement | null) => void;
    tag: InputElement | null;
};

const TagRemovalConfirmation = ({
    isOpen,
    onClose,
    onSubmit,
    tag,
}: Props) => {
    const intl = useIntl();

    const onFinalSubmit = () => {
        onSubmit(tag);
        onClose();
    };

    return (
        <Modal
            open={isOpen}
            onRequestClose={onClose}
            onRequestSubmit={onFinalSubmit}
            danger
            modalHeading={intl.formatMessage(messages.heading)}
            modalLabel={intl.formatMessage(sharedMessages.irreversibleAction)}
            primaryButtonText={intl.formatMessage(sharedMessages.submit)}
            closeButtonLabel={intl.formatMessage(sharedMessages.cancel)}
            secondaryButtonText={intl.formatMessage(sharedMessages.back)}
        />
    );
};

const messages = defineMessages({
    heading: {
        id: 'src.Components.Common.TagsInput.TagRemovalConfirmation.TagRemovalConfirmation.heading',
        defaultMessage: 'Czy na pewno chcesz usunąć ten element?',
    },
});

export default TagRemovalConfirmation;
